import React  from "react";
import {FormControl} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Autocomplete from "@mui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import TextField from "@mui/material/TextField";
import {Controller} from "react-hook-form";
import {validArray} from "../../util/functions";
import {isEmpty} from "../../util/is";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const AutocompleteForm = ({value = [], identificador, className, dataList, disabled = false, placeholder, onChange, inputProps = {}, required = true, label, customError = null}) => {

    return(
        <FormControl  key={`key${identificador}`}  variant="outlined" className={`my-1 ${className}`}>
            {
                !("control" in inputProps) ?
                <Autocomplete
                    multiple
                    disabled={disabled}
                    options={dataList || []}
                    disableCloseOnSelect
                    value={value}
                    limitTags={2}
                    onChange={(event, value) => onChange({name: identificador, value})}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.text}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.text}
                      </li>
                    )}
                    style={{ width: '100%', zIndex: 99999, boxShadow: '0 2px 5px 0 rgb(0 0 0 / 4%)'}}
                    renderInput={(params) => (
                        <TextField {...params}  variant="outlined" label={label} placeholder={placeholder} />
                    )}
                />
                :
                <Controller
                    rules={{ required: required }}
                    control={inputProps.control}
                    defaultValue={[]}
                    name={identificador}
                    render={({ field: { onChange, onBlur, value } }) =>
                        (<Autocomplete
                            multiple
                            limitTags={2}
                            disabled={disabled}
                            options={validArray(dataList)}
                            disableCloseOnSelect
                            value={value}
                            onBlur={onBlur}
                            className="bg-white w-100"
                            onChange={(event, value) => onChange(value)}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            getOptionLabel={(option) => option?.text}
                            renderOption={(props, option, { selected }) => (
                              <li {...props}>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                {option.text}
                              </li>
                            )}
                            style={{ width: '100%', boxShadow: '0 2px 5px 0 rgb(0 0 0 / 4%)'}}
                            renderInput={(params) => (
                                <TextField {...params}  variant="outlined" label={label} placeholder={placeholder} />
                            )}
                        />)
                    }
                />

            }
            {
              (!isEmpty(customError) || required) &&
                <span className="mt-1 pl-2 titleForm panelColorError">{customError}</span>
            }

        </FormControl>
    )

}

export default AutocompleteForm;
